module.exports = __webpack_public_path__ + "static/media/loginbg.25d687d3.jpg";